import {
    type ProductCategoryTyping,
    type ProductTyping,
    type SpaceTyping,
} from '@/typings/widget';
import axios from 'axios';

export const getProductCategories = async(venueId: string, locale: string): Promise<ProductCategoryTyping[]> => {
    const response = await axios
        .post(
            `${import.meta.env.VITE_API_BASE_URL}/api/v1/public/product-category/list`, {}, {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept-Language': locale,
                    'X-Venue-Id': venueId,
                },
            },
        );
    return ((response.data as { items?: ProductCategoryTyping[] }).items ?? []);
};

export const getProducts = async(venueId: string, locale: string): Promise<ProductTyping[]> => {
    const response = await axios
        .post(
            `${import.meta.env.VITE_API_BASE_URL}/api/v1/public/product/list`, {}, {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept-Language': locale,
                    'X-Venue-Id': venueId,
                },
            },
        );
    return ((response.data as { items?: ProductTyping[] }).items ?? []);
};

export const getSpaces = async(venueId: string, locale: string): Promise<SpaceTyping[]> => {
    const response = await axios
        .post(
            `${import.meta.env.VITE_API_BASE_URL}/api/v1/public/space/list`, {}, {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept-Language': locale,
                    'X-Venue-Id': venueId,
                },
            },
        );
    return ((response.data as { items?: SpaceTyping[] }).items ?? []);
};
